// NewSidebar/iconMap.js
import React from "react";
import Dashboard from "../Icon/Dashboard";
import OrderIcon from "../Icon/OrderIcon";
import CustomerIcon from "../Icon/CustomerIcon";
import PlateQcIcon from "../Icon/PlateQcIcon";
import Production from "../Icon/Production";
import ReportIcon from "../Icon/ReportsIcon";
import MaterialIcon from "../Icon/MaterialIcon";
import SideBardStoreIocn from "../Icon/SideBardStoreIocn";
import BasicInformation from "../Icon/BasicInformation";
import PersonFormIcon from "../Icon/PersonFormIcon";
import ContactIcon from "../Icon/ContactIcon";
import TicketIcon from "../Icon/TicketIcon";
import SchedulerIcon from "../Icon/schedulerIcon";
import PrintAssistant from "../Icon/PrintAssistant";
import LogOutIcon from "../Icon/LogOutIcon";
import CustomerOrdersArchivedIcon from "../Icon/CustomerOrdersArchivedIcon";
import OrderPaymentIcon from "../Icon/OrderPaymentIcon";
import OclockOrderPaymentIcon from "../Icon/OclockOrderPaymentIcon";
import DesignerIcon from "../Icon/DesignerIcon";
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import MapIcon from '@mui/icons-material/Map';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PublicIcon from '@mui/icons-material/Public';
import GroupsIcon from '@mui/icons-material/Groups';
import CategoryIcon from '@mui/icons-material/Category';
import PersonIcon from '@mui/icons-material/Person';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

import EditNoteIcon from '@mui/icons-material/EditNote';

/**
 * مپ نام آیکون (string) به کامپوننت React
 * کلیدها دقیقاً مطابق مقدار "icon" در sidebarMenu.json هستند
 */
const iconMap = {
  Dashboard: <Dashboard />,
  OrderIcon: <OrderIcon />,
  CustomerIcon: <CustomerIcon />,
  PlateQcIcon: <PlateQcIcon />,
  Production: <Production />,
  ReportIcon: <ReportIcon />,
  MaterialIcon: <MaterialIcon />,
  SideBardStoreIocn: <SideBardStoreIocn />,
  BasicInformation: <BasicInformation />,
  PersonFormIcon: <PersonFormIcon />,
  ContactIcon: <ContactIcon />,
  TicketIcon: <TicketIcon />,
  SchedulerIcon: <SchedulerIcon />,
  PrintAssistant: <PrintAssistant />,
  LogOutIcon: <LogOutIcon />,
  CustomerOrdersArchivedIcon: <CustomerOrdersArchivedIcon />,
  OrderPaymentIcon: <OrderPaymentIcon />,
  OclockOrderPaymentIcon: <OclockOrderPaymentIcon />,
  DesignerIcon: <DesignerIcon />,

  customerMachineType: <SettingsApplicationsIcon/>,
  pathDefinition:<MapIcon/>,
  customerSettlementType:<ReceiptLongIcon/>,
  regionDefinition:<PublicIcon/>,
  customerMachine:<PrecisionManufacturingOutlinedIcon/>,
  customerGroup:<GroupsIcon/>,
  customerProducts:<CategoryIcon/>,
  customers:<PersonIcon/>,
  preOrder:<EditNoteIcon/>,
  exit:<LogOutIcon/>,

  // آیکون خاص «کنترل و نظارت» که از فونت‌آیکون استفاده می‌کند
  ControlIcon: (
    <i
      style={{ color: "white" }}
      className="icon-Password-Minimalistic-Input"
    />
  ),
};

export default iconMap;
